

























import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'
import CoreList from '../../core/components/list/index.vue'
import { displayDateTime, capitalize, simpleDate, money } from '../../core/utils'

@Component({
  components: {
    CoreList
  }
})
export default class UserPracticumList extends Vue {
  breadcrumbs = [{ text: 'Practicum Students', url: '/admin/practicums' }]

  loading = false

  filterOptions = [
    { text: 'ID', key: 'id', type: 'number' },
    { text: 'Given Name', key: 'givenName', type: 'string' },
    { text: 'Surname', key: 'surname', type: 'string' },
    { text: 'Enrolled', key: 'enrolled', type: 'date' },
    { text: 'Certified', key: 'certified', type: 'date' },
    {
      text: 'Status',
      key: 'status',
      type: 'enum',
      options: [{ value: 'in-progress', text: 'In Progress' }, { value: 'completed', text: 'Completed' }] }
  ]

  availableColumns = [
    { text: 'ID', value: 'id' },
    { text: 'Given Name', value: 'userGivenName' },
    { text: 'Surname', value: 'userSurname' },
    { text: 'Enrolled', value: 'enrolled', display: this.formatDate },
    { text: 'Certified', value: 'certified', display: this.formatDate },
    { text: 'Status', value: 'status', display: this.splitCapitalize }
  ]

  defaultColumns = ['id', 'userGivenName', 'userSurname', 'enrolled', 'status', 'certified']

  actions = [
    { text: 'Mark as Completed', method: this.certifyItem, visible: (i: any) => i.status === 'in-progress' },
    { text: 'View User', method: this.viewUser }
  ]

  public async viewUser(item: any) {
    this.$router.push(`users/${item.userId}`)
  }

  public async certifyItem(item: any) {
    try {
      this.loading = true
      await axios.post(`/practicums/${item.practicumId}/users/${item.userId}/finish`)
      const text = `${item.userGivenName} ${item.userSurname} was successfully certified`
      this.$store.dispatch('showSuccess', text)
      this.loading = false
      const list = this.$refs.list as any
      list.updateResults()
    } catch (err) {
      this.$store.dispatch('showError', 'An unexpected error occurred')
    }
  }

  public formatDate(date: string | Date) {
    return displayDateTime(date)
  }

  private splitCapitalize(text: string) {
    return text.split('-').map(i => capitalize(i)).join(' ')
  }
}
